import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'
window.Alpine = Alpine

const pwaDismissedStorageKey = 'mtm360:pwa-install-toast-dismissed-at'
const pwaDismissalDuration = 7 * 24 * 60 * 60 * 1000
let nativePwaInstallPromptAvailable = false

function getPwaDismissedAt() {
  try {
    return Number.parseInt(window.localStorage.getItem(pwaDismissedStorageKey) || '0', 10)
  } catch (error) {
    return 0
  }
}

function isPwaDismissed() {
  const dismissedAt = getPwaDismissedAt()
  return dismissedAt > 0 && Date.now() - dismissedAt < pwaDismissalDuration
}

function dismissPwaToast(toast) {
  try {
    window.localStorage.setItem(pwaDismissedStorageKey, String(Date.now()))
  } catch (error) {
    // Storage can be unavailable in private browsing modes.
  }

  toast.classList.add('pwa-a2hs-dismissed')
  toast.setAttribute('hidden', 'hidden')
  toast.style.setProperty('display', 'none', 'important')
}

function isIos() {
  const platform = window.navigator.platform || ''
  const userAgent = window.navigator.userAgent || ''

  return /iPad|iPhone|iPod/.test(userAgent) || (platform === 'MacIntel' && window.navigator.maxTouchPoints > 1)
}

function isIosSafari() {
  const userAgent = window.navigator.userAgent || ''

  return isIos() && /Version\/[\d.]+.*Safari/.test(userAgent) && !/CriOS|FxiOS|EdgiOS|OPiOS|DuckDuckGo/.test(userAgent)
}

function isPwaStandalone() {
  return window.navigator.standalone === true || window.matchMedia?.('(display-mode: standalone)').matches
}

function revealIosPwaToast(toast) {
  toast.classList.remove('pwa-a2hs', 'hidden', 'pwa-a2hs-dismissed')
  toast.classList.add('pwa-a2hs-active', 'pwa-a2hs-ios', 'show')
  toast.removeAttribute('hidden')
  toast.style.removeProperty('display')
}

function maybeShowIosPwaToast(toast) {
  if (!isIosSafari() || isPwaStandalone() || isPwaDismissed() || nativePwaInstallPromptAvailable) {
    return
  }

  revealIosPwaToast(toast)
}

function attachPwaToasts(context = document) {
  context
    .querySelectorAll?.('.pwa-a2hs, .pwa-a2hs-active')
    .forEach((toast) => preparePwaToast(toast))
}

function preparePwaToast(toast) {
  if (toast.dataset.pwaToastReady === 'true') {
    if (isPwaDismissed()) {
      toast.classList.add('pwa-a2hs-dismissed')
    }
    return
  }

  toast.dataset.pwaToastReady = 'true'

  const closeButton = document.createElement('button')
  closeButton.type = 'button'
  closeButton.className = 'pwa-a2hs-close'
  closeButton.setAttribute('aria-label', 'Dismiss install prompt')
  closeButton.innerHTML = '<span aria-hidden="true">&times;</span>'
  toast.append(closeButton)

  if (isPwaDismissed()) {
    dismissPwaToast(toast)
    return
  }

  maybeShowIosPwaToast(toast)
}

Drupal.behaviors.vanguardPwaInstallToast = {
  attach(context) {
    attachPwaToasts(context)
  },
}

function handlePwaClose(event) {
  const closeButton = event.target.closest?.('.pwa-a2hs-close')
  if (!closeButton) {
    return
  }

  event.preventDefault()
  event.stopPropagation()
  event.stopImmediatePropagation()

  const toast = closeButton.closest('.pwa-a2hs, .pwa-a2hs-active')
  if (toast) {
    dismissPwaToast(toast)
  }
}

document.addEventListener('click', handlePwaClose, true)
document.addEventListener('touchend', handlePwaClose, true)

window.addEventListener('beforeinstallprompt', () => {
  nativePwaInstallPromptAvailable = true
})

attachPwaToasts()

Alpine.plugin(collapse)
Alpine.start()
